import styled from 'styled-components'
/**
 * Styled component is used to decorate SplashScreen component.
 * Props are passed from ThemeProvider component.
 */
export const SplashPageStyle = styled.div`
  display: grid;
  justify-content: center;
  grid-template-columns: 40% 40%;
  grid-template-rows: 40% 40%;
  row-gap: 3%;
  column-gap: 3%;
  padding-bottom: 3%;
  max-width: 1440px;
  @media screen and (max-width: 675px) {
    display: flex;
    flex-direction: column;
  }
`
export const SplashWrapper = styled.div`
  display: grid;
  justify-items: center;
  margin-bottom: 3em;
`
